import { Skeleton } from '@hvac/ui';
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { Link, useParams } from '@tanstack/react-router';
import { useEffect } from 'react';
import { invoiceQuery } from '../../shared/api/invoicing-queries.js';
import { sessionQuery } from '../../shared/api/queries.js';
import { InvoiceDocumentView } from './invoice-document.js';

/**
 * The invoice alone on a white page, for the browser's print dialog, which
 * is also how it becomes a PDF. Opens the dialog once the document is in.
 */
export function InvoicePrintPage() {
  const { invoiceId } = useParams({ from: '/invoices/$invoiceId/print' });
  const { data: session } = useSuspenseQuery(sessionQuery());
  const organizationId = session.activeOrganizationId ?? '';
  const invoice = useQuery(invoiceQuery(organizationId, invoiceId));

  useEffect(() => {
    if (invoice.data === undefined) return;
    const timer = window.setTimeout(() => {
      window.print();
    }, 300);
    return () => window.clearTimeout(timer);
  }, [invoice.data]);

  return (
    <main className="min-h-dvh bg-white">
      <div className="mx-auto flex max-w-3xl items-center justify-between px-8 py-3 text-sm print:hidden">
        <Link
          to="/invoices/$invoiceId"
          params={{ invoiceId }}
          className="text-neutral-600 hover:text-black"
        >
          ← Back to the invoice
        </Link>
        <button
          type="button"
          onClick={() => {
            window.print();
          }}
          className="rounded border border-neutral-300 px-3 py-1 text-neutral-800 hover:bg-neutral-100"
        >
          Print or save as PDF
        </button>
      </div>
      {invoice.data === undefined ? (
        <div className="mx-auto max-w-3xl p-8">
          <Skeleton className="h-64 w-full" />
        </div>
      ) : (
        <InvoiceDocumentView document={invoice.data} />
      )}
    </main>
  );
}
